import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {ActionLink, Panel} from 'shared/components';
import BankingChequeHelperModal from './BankingChequeHelperModal';
import EditBankingInfoModal from './EditBankingInfoModal';
import {t} from 'shared/core';
import {auth} from 'main/tools';
import EmployeeProfileContainer from '../../EmployeeProfileContainer';
import SinInfo from './SinInfo';
import BankingInfo from './BankingInfo';
import NmbrPayStubsTable from './NmbrPayStubsTable';
import NmbrTaxDocumentsTable from './NmbrTaxDocumentsTable';

const ToggleBankingInfoButton = observer(({uiState}) => {
  if (uiState.bankingInformationHidden) {
    return (
      <ActionLink onClick={() => uiState.showBankingInformation()}>
        <FormattedMessage id='employees.profile.banking.Show'/>
      </ActionLink>
    );
  }

  return (
    <ActionLink onClick={() => uiState.hideBankingInformation()}>
      <FormattedMessage id='employees.profile.banking.Hide'/>
    </ActionLink>
  );
});

const BankingContainer = observer(({uiState}) => {
  const {employee, nmbrPayStubs, userIsEmployee} = uiState;

  return (
    <EmployeeProfileContainer uiState={uiState}>
      <div className='fs-hide'>
        <Panel.Stack loose>
          {uiState.viewDataPermission('::BANKING_INFORMATION') && (auth.company.bankingEnabled || auth.company.sinEnabled) && <Panel>
            <Panel.Header title={t('employees.profile.banking.Banking Information')}>
              <ToggleBankingInfoButton uiState={uiState}/>
              {uiState.editDataPermission('::BANKING_INFORMATION') &&
                <ActionLink onClick={() => uiState.openBankingInfoModal()} className='ml2'>
                  <FormattedMessage id='employees.profile.banking.Edit'/>
                </ActionLink>}
            </Panel.Header>
            <SinInfo uiState={uiState}/>
            <BankingInfo uiState={uiState}/>
          </Panel>}
          {employee.existsInNmbr && auth.company.showNmbrPayroll && (auth.hasAccess('::PAYROLL') || userIsEmployee) && <NmbrPayStubsTable employee={employee}/>}
          {employee.existsInNmbr && auth.company.showNmbrPayroll && (auth.hasAccess('::PAYROLL') || userIsEmployee) && <NmbrTaxDocumentsTable employee={employee}/>}
        </Panel.Stack>
        <BankingChequeHelperModal uiState={uiState}/>
        <EditBankingInfoModal uiState={uiState}/>
      </div>
    </EmployeeProfileContainer>
  );
});

export default BankingContainer;
